import precomputedBuildings from '../../config/precomputed-buildings.json'

import { getCombinedCount, getFrequencyCount } from '../../helpers/filterSquads'
import { LiveGameEco } from './LiveGameEcoUnit'
import { LiveGameEcoBuilding } from './LiveGameEcoBuilding'
import { LiveGameMilitaryBuilding } from './LiveGameMilitaryBuilding'
import { LiveGameSeperator } from './LiveGameSeperator'
import classNames from 'classnames'
import { LiveGameTechDisplay } from './LiveGameTechDisplay'
import { VizierDisplay } from './CivUnique/VizierDisplay'
import { LiveGameLandmarkDisplay } from './LiveGameLandmarkDisplay'
import { useQuery } from 'react-query'
import { LiveGameKeyTech } from './LiveGameKeyTech'
import { useSocketState } from '../../helpers/useSocket'
import { TughlaqGovernor } from './CivUnique/TughlaqGovernor'
import { getBackendUrl } from '../../helpers/url'

function getLandmarks(buildings) {
	let array = Array(4)
	//Dark Age will always be a Towncenter, well add it so we can have it
	array[0] = buildings
		.filter((b) => precomputedBuildings.town_center.includes(b.pbg_id))
		.map((b) => b.pbg_id)

	array[1] = buildings
		.filter((b) =>
			[
				...precomputedBuildings.age1_landmark1,
				...precomputedBuildings.age1_landmark2,
			].includes(b.pbg_id),
		)
		.map((b) => b.pbg_id)
	array[2] = buildings
		.filter((b) =>
			new Set([
				...precomputedBuildings.age2_landmark1,
				...precomputedBuildings.age2_landmark2,
			]).has(b.pbg_id),
		)
		.map((b) => b.pbg_id)
	array[3] = buildings
		.filter((b) =>
			new Set([
				...precomputedBuildings.age3_landmark1,
				...precomputedBuildings.age3_landmark2,
			]).has(b.pbg_id),
		)
		.map((b) => b.pbg_id)
	return array
}

function getAgeUpAsUpgrade(upgrades) {
	let array = Array(4)
	array[1] = upgrades
		.filter((b) =>
			[precomputedBuildings.landmarkUpgrades].includes(b.pbg_id),
		)
		.map((b) => b.pbg_id)
}

export function LiveGameOverviewer({ playerData, leftSide, color }) {
	const [match] = useSocketState('Match')

	const fetchCivs = async () => {
		const res = await fetch(`${getBackendUrl()}/api/config/civs`)
		return res.json()
	}

	const { data, status } = useQuery('civs', fetchCivs)

	const selectedCiv = data?.find(
		(value) =>
			value.aoe2cm === playerData?.civilization ||
			value.label === playerData?.civilization,
	)

	let playerBuildings = Object.values(playerData?.entities || [])
	let playerTechs = Object.values(playerData?.technologies_researched || [])

	let landmarks = getLandmarks(playerBuildings)
	let ageUpAsUpgrade = playerTechs.filter((t) =>
		precomputedBuildings.landmarkUpgrades.includes(parseInt(t)),
	)

	let farmIcon = selectedCiv?.farmType || 199747

	//Leaving this here since we might want to display Docks later, but unsure
	let dockCount = 0 //getFrequencyCount(playerBuildings, precomputedBuildings.docks)

	//Convert from the IDs that hossein used in the extract to images, remember that LUA does arrays starting to 1
	let tughlaqGovernorIds = {
		1: 'governor_armor', //Ajmer
		2: 'governor_food', //Bakkhar
		3: 'governor_cavalry', //Jalor
		4: 'governor_villager', //Multan
		5: 'governor_religious', //Sehwan
		6: 'governor_upgrade', //Uch
	}

	console.log(playerData?.tughlaq_fort)

	return (
		<div
			className={classNames(
				`w-[250px] h-[310px] border-solid border flex flex-col scale-90`,
				leftSide ? '-ml-3' : '-mr-3',
			)}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: 'url("/sheepCounter/background.png")',
			}}
		>
			<div
				className={classNames(
					'flex w-auto h-[150px]',
					leftSide ? 'flex-row ' : 'flex-row-reverse ',
				)}
			>
				<div
					className={classNames(
						'flex flex-col flex-wrap gap-1 justify-center h-full',
						leftSide ? 'ml-1 mr-3' : 'mr-1 ml-3',
					)}
				>
					<LiveGameEcoBuilding
						pbgid={199640}
						count={getFrequencyCount(
							playerBuildings,
							precomputedBuildings.town_center,
						)}
						inQueue={0}
						leftSide={leftSide}
						showCount={true}
					/>
					<LiveGameEcoBuilding
						pbgid={farmIcon}
						count={getFrequencyCount(playerBuildings, [farmIcon])}
						inQueue={0}
						leftSide={leftSide}
						showCount={true}
					/>
					<LiveGameEcoBuilding
						pbgid={199632}
						count={getFrequencyCount(
							playerBuildings,
							precomputedBuildings.exchange,
						)}
						inQueue={0}
						leftSide={leftSide}
						showCount={true}
					/>
				</div>

				<div
					className={classNames(
						'w-[21px] my-auto',
						leftSide ? '' : '-mr-6 ml-2',
					)}
				>
					<LiveGameSeperator />
				</div>

				<div
					className={classNames(
						'flex flex-col flex-wrap gap-1 justify-center h-full w-1/3',
						leftSide ? '-ml-[12px]' : '-mr-[12px]',
					)}
				>
					{playerData?.civilization === 'Macedonian Dynasty' ? (
						//This is for the Stronghold since the Macedonian don't have a barracks
						<LiveGameMilitaryBuilding
							pbgid={9001600}
							count={getFrequencyCount(
								playerBuildings,
								[9001600],
							)}
							inQueue={0}
							leftSide={leftSide}
							showCount={true}
						/>
					) : (
						<LiveGameMilitaryBuilding
							pbgid={145521}
							count={getFrequencyCount(
								playerBuildings,
								precomputedBuildings.barracks,
							)}
							inQueue={0}
							leftSide={leftSide}
							showCount={true}
						/>
					)}
					<LiveGameMilitaryBuilding
						pbgid={199645}
						count={getFrequencyCount(
							playerBuildings,
							precomputedBuildings.archery_range,
						)}
						inQueue={0}
						leftSide={leftSide}
						showCount={true}
					/>
					<LiveGameMilitaryBuilding
						pbgid={129993}
						count={getFrequencyCount(
							playerBuildings,
							precomputedBuildings.stable,
						)}
						inQueue={0}
						leftSide={leftSide}
						showCount={true}
					/>
				</div>

				<div
					className={classNames(
						'flex flex-col flex-wrap gap-1 justify-start pt-[11px] h-full w-1/3 scale-90',
						leftSide ? '' : '',
					)}
				>
					{dockCount >= 1 && (
						<LiveGameMilitaryBuilding
							pbgid={199644}
							count={dockCount}
							inQueue={0}
							leftSide={leftSide}
							showCount={true}
						/>
					)}
					{[
						'Abbasid Dynasty',
						'Ayyubids',
						'Knights Templar',
						'Golden Horde',
					].includes(playerData?.civilization) ? (
						<>
							{ageUpAsUpgrade.map((v, i) => {
								return (
									<div className="flex flex-row justify-center upgrade">
										<LiveGameLandmarkDisplay
											pbgid={v}
											showCount={false}
											isKT={
												playerData?.civilization ===
												'Knights Templar'
											}
										/>
									</div>
								)
							})}
						</>
					) : (
						<>
							<div className="flex flex-row justify-center">
								{playerData?.age >= 1 &&
									landmarks[1].map((v, i) => (
										<LiveGameLandmarkDisplay
											key={v}
											pbgid={v}
											showCount={false}
										/>
									))}
							</div>
							<div className="flex flex-row justify-center">
								{playerData?.age >= 2 &&
									landmarks[2].map((v, i) => (
										<LiveGameLandmarkDisplay
											key={v}
											pbgid={v}
											showCount={false}
										/>
									))}
							</div>
							<div className="flex flex-row justify-center">
								{playerData?.age >= 3 &&
									landmarks[3].map((v, i) => (
										<LiveGameLandmarkDisplay
											key={v}
											pbgid={v}
											showCount={false}
										/>
									))}
							</div>
						</>
					)}
				</div>
			</div>

			<div className="flex flex-col px-1 -mt-1 mb-2">
				{playerData?.civilization === 'Rus' && (
					<div
						className={classNames(
							'flex',
							leftSide ? 'flex-row' : 'flex-row-reverse',
						)}
					>
						<LiveGameEcoBuilding
							pbgid={172205}
							count={getFrequencyCount(playerBuildings, [172205])}
							inQueue={0}
							leftSide={leftSide}
							showCount={true}
						/>
						<div className="flex flex-row my-auto mx-4">
							<h1 className="text-white text-xl">
								{parseInt(
									playerData.statetree.data
										.hunting_cabin_player_gold_rate_rus,
								)}
							</h1>
							<img
								className="w-9"
								src={`/liveGameIcons/gold.png`}
								alt=""
							/>
							<h1 className="text-[#b1b1b1] ">/min</h1>
						</div>
					</div>
				)}
				{playerData?.civilization === 'Chinese' && (
					<div
						className={classNames(
							'flex gap-[19px]',
							leftSide ? 'flex-row' : 'flex-row-reverse',
						)}
					>
						<LiveGameEcoBuilding
							pbgid={156481}
							count={getFrequencyCount(playerBuildings, [156481])}
							inQueue={0}
							leftSide={leftSide}
							showCount={true}
						/>
						<LiveGameEcoBuilding
							pbgid={156488}
							count={getFrequencyCount(playerBuildings, [156488])}
							inQueue={0}
							leftSide={leftSide}
							showCount={true}
						/>
					</div>
				)}

				{playerData?.civilization === "Zhu Xi's Legacy" && (
					<div
						className={classNames(
							'flex',
							leftSide ? 'flex-row' : 'flex-row-reverse',
						)}
					>
						{getFrequencyCount(playerBuildings, [6065722]) ? (
							<>
								<LiveGameLandmarkDisplay
									key={'medgarden'}
									pbgid={6065722}
									showCount={false}
								/>
								<div className="flex flex-row my-auto mx-4 gap-1">
									{playerData.statetree.data
										.meditation_gardens_total_food_generation >=
										2 && (
										<div className="flex flex-row">
											<h1 className="text-white text">
												{parseInt(
													playerData.statetree.data
														.meditation_gardens_total_food_generation,
												)}
											</h1>
											<img
												className="w-8 h-7"
												src={`/liveGameIcons/food.png`}
												alt=""
											/>
										</div>
									)}
									{playerData.statetree.data
										.meditation_gardens_total_wood_generation >=
										2 && (
										<div className="flex flex-row">
											<h1 className="text-white text">
												{parseInt(
													playerData.statetree.data
														.meditation_gardens_total_wood_generation,
												)}
											</h1>
											<img
												className="w-8 h-7"
												src={`/liveGameIcons/wood.png`}
												alt=""
											/>
										</div>
									)}
									{playerData.statetree.data
										.meditation_gardens_total_gold_generation >=
										2 && (
										<div className="flex flex-row">
											<h1 className="text-white text">
												{parseInt(
													playerData.statetree.data
														.meditation_gardens_total_gold_generation,
												)}
											</h1>
											<img
												className="w-8 h-7"
												src={`/liveGameIcons/gold.png`}
												alt=""
											/>
										</div>
									)}
									{playerData.statetree.data
										.meditation_gardens_total_stone_generation >=
										2 && (
										<div className="flex flex-row">
											<h1 className="text-white text">
												{parseInt(
													playerData.statetree.data
														.meditation_gardens_total_stone_generation,
												)}
											</h1>
											<img
												className="w-8 h-7"
												src={`/liveGameIcons/stone.png`}
												alt=""
											/>
										</div>
									)}
								</div>
							</>
						) : (
							<></>
						)}
					</div>
				)}
			</div>

			<div
				className={classNames(
					'flex flex-col gap-4 px-4',
					leftSide ? '' : 'items-end',
				)}
			>
				{playerData?.civilization === 'Ottomans' && (
					<VizierDisplay
						upgrades={playerTechs}
						hasImperialCouncil={playerBuildings.includes(2055470)}
						leftSide={leftSide}
					/>
				)}

				{playerData?.civilization === 'Tughlaq Dynasty' && (
					<div className="flex flex-row flex-wrap gap-[2px]">
						{playerData?.tughlaq_fort.map((governor, i) => (
							<TughlaqGovernor
								governor={tughlaqGovernorIds[governor['2']]}
								level={governor['3']}
								leftSide={leftSide}
							/>
						))}
					</div>
				)}

				{/* Used for Macedonian since they have some "keyTechs" that has levels to them that we want to show in the overview */}
				{playerData?.civilization === 'Macedonian Dynasty' && (
					<div
						className={classNames(
							'flex flex-wrap gap-1',
							leftSide ? 'flex-row' : 'flex-row-reverse',
						)}
					>
						{selectedCiv?.hiddenKeyTechs.map((tech, index) => (
							<LiveGameKeyTech
								key={index}
								color={color}
								tech={tech}
								currentUpgrades={
									playerData?.technologies_researched
								}
							/>
						))}
					</div>
				)}

				{selectedCiv?.uniqueTechs.map((row, rowIndex) => (
					<div
						key={rowIndex}
						className={classNames(
							'flex flex-wrap gap-1',
							leftSide ? 'flex-row' : 'flex-row-reverse',
						)}
					>
						{row.map((tech, i) => (
							<LiveGameTechDisplay
								key={tech + String(i)}
								pbg_id={tech}
								hasTech={playerTechs.includes(String(tech))}
							/>
						))}
					</div>
				))}
				{/* This is used for French and JD where their unique techs are in 2 places with seperate ID's */}
				<div
					className={classNames(
						'flex flex-wrap gap-1',
						leftSide ? 'flex-row' : 'flex-row-reverse',
					)}
				>
					{selectedCiv?.duplicateUniqueTechs?.map((tech, i) => (
						<LiveGameTechDisplay
							key={tech.name + String(i)}
							pbg_id={tech.ids[0]}
							hasTech={tech.ids.some((t) =>
								playerTechs.includes(String(t)),
							)}
						/>
					))}
				</div>
			</div>
		</div>
	)
}
